<template>
  <div class="lp-container">
    <FirstView />
    <QuestionSlide />
    <RecommendedVendor />
    <SelectionCriteria />
    <VendorRankingTitle />
    <RankingAndComparison defaultTab="comparison" />
    <VendorDetail />
    <TipsCard />
    <RankingAndComparison />
    <InquiryFlow />
    <QuestionAnswer />
    <ScrollRecommend />
  </div>
</template>

<script setup>
import FirstView from '@/components/header/FirstView.vue'
import QuestionSlide from '@/components/diagnosis/QuestionSlide.vue'
import RecommendedVendor from '@/components/recommend/RecommendedVendor.vue'
import SelectionCriteria from '@/components/criterion/SelectionCriteria.vue'
import VendorDetail from '@/components/vendor/VendorDetail.vue'
import RankingAndComparison from '@/components/ranking/RankingAndComparison.vue'
import QuestionAnswer from '@/components/question/QuestionAnswer.vue'
import ScrollRecommend from '@/components/footer/ScrollRecommend.vue'
import VendorRankingTitle from '@/components/ranking/VendorRankingTitle.vue'
import TipsCard from '@/components/tips/TipsCard.vue'
import InquiryFlow from '@/components/flow/InquiryFlow.vue'
</script>

<style scoped>
.lp-container {
  text-align: center;
  color: #2c3e50;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  background-color: white;
  min-height: 100dvh;
  height: auto;
}

.double-circle {
  width: 40px;
  height: 40px;
  position: relative;
  border: solid #fa8072 5px;
  border-radius: 50%;
  box-sizing: border-box;
  margin: 0 auto;
}

.double-circle::before {
  content: "";
  width: 25px;
  height: 25px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: solid #fa8072 5px;
  border-radius: 50%;
  box-sizing: border-box;
}

.cross {
  position: relative;
  width: 40px;
  height: 40px;
  margin: 0 auto;
}

.cross::before,
.cross::after {
  content: "";
  position: absolute;
  top: 18px;
  left: -4px;
  width: 40px;
  height: 6px;
  background: #607d8b;
}

.cross::before {
  transform: rotate(45deg);
}

.cross::after {
  transform: rotate(-45deg);
}

.circle {
  width: 30px;
  height: 30px;
  border: 6px solid #409fca;
  border-radius: 50%;
  margin: 0 auto;
}

.triangle {
  --b: 12px;
  width: 50px;
  aspect-ratio: 1/cos(30deg);
  clip-path: polygon(50% 0, 100% 100%, 0 100%, 50% 0, 50% var(--b), calc(var(--b)*cos(30deg)) calc(100% - var(--b)/2), calc(100% - var(--b)*cos(30deg)) calc(100% - var(--b)/2), 50% var(--b));
  background: #ffc107;
  margin: 0 auto;
}

.bold-red {
  color: #e74c3c;
  font-weight: bold;
}

.under-yellow {
  background: linear-gradient(transparent 65%, rgb(253 233 61) 50%);
  font-weight: 600;
}

.bold-font {
  font-weight: 600;
}
</style>
